export default __webpack_public_path__ + "media/samples/FUNDAMENTALS_3_New-fcfd2dfd.jpeg";